/* LOVE LACE — product page: variant picker, add to bag, gallery + lightbox,
   size guide, sticky mobile bar, and the Related / Upsell tabs. */
(function () {
  'use strict';
  var doc = document, win = window, LL = win.LoveLace || {};
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function money(cents) {
    var fmt = LL.moneyFormat || '£{{amount}}', n = cents / 100;
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/<[^>]*>/g, '');
  }
  function lock(on) { doc.documentElement.classList.toggle('ll-lock', on); }

  /* ================= product ================= */
  function initPdp(root) {
    if (!root || root.__ll) return; root.__ll = true;
    var form = $('[data-ll-product-form]', root);
    var variants = []; try { variants = JSON.parse($('[data-ll-variants]', root).textContent); } catch (e) {}
    var stock = {}; try { stock = JSON.parse($('[data-ll-stock-map]', root).textContent); } catch (e) {}
    var idInput = $('[data-ll-variant-id]', root);
    var addBtn = $('[data-ll-add-btn]', root), addLabel = $('[data-ll-add-label]', root);
    var msg = $('[data-ll-pdp-msg]', root), stockEl = $('[data-ll-stock]', root);
    var sets = $$('[data-ll-opt]', root);
    var current = null;

    function selected() { return sets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function find(sel) {
      if (!sets.length) return variants[0] || null;
      if (sel.indexOf(null) > -1) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(sel) {
      sets.forEach(function (fs, oi) {
        $$('input', fs).forEach(function (inp) {
          var possible = variants.some(function (v) {
            if (!v.available || v.options[oi] !== inp.value) return false;
            for (var j = 0; j < sel.length; j++) if (j !== oi && sel[j] !== null && v.options[j] !== sel[j]) return false;
            return true;
          });
          inp.nextElementSibling.classList.toggle('is-out', !possible);
        });
      });
    }
    function missingName() {
      var sel = selected();
      for (var i = 0; i < sel.length; i++) if (sel[i] === null) return (sets[i].querySelector('.ll-opt__legend span').textContent || 'option').replace(':', '').trim().toLowerCase();
      return null;
    }
    function update(fromUser) {
      var sel = selected();
      sets.forEach(function (fs, i) { var l = $('[data-ll-opt-label]', fs); if (l) l.textContent = sel[i] || ''; fs.classList.remove('is-invalid'); });
      markAvailability(sel);
      var v = find(sel); current = v;
      idInput.value = v ? v.id : '';
      var now = $('[data-ll-price-now]', root), was = $('[data-ll-price-was]', root), save = $('[data-ll-price-save]', root);
      var ref = v || variants.filter(function (x) { return x.available; })[0] || variants[0];
      if (ref && now) {
        now.textContent = money(ref.price);
        var sale = ref.compare_at_price && ref.compare_at_price > ref.price;
        was.hidden = save.hidden = !sale;
        if (sale) { was.lastChild.textContent = money(ref.compare_at_price); save.textContent = 'Save ' + Math.round((ref.compare_at_price - ref.price) * 100 / ref.compare_at_price) + '%'; }
        $('[data-ll-price]', root).classList.toggle('ll-price--sale', !!sale);
        var bp = $('[data-ll-bar-price]', root); if (bp) bp.textContent = money(ref.price);
      }
      var miss = missingName();
      if (!v) {
        addBtn.disabled = false;
        addLabel.textContent = miss ? 'Select a ' + miss : 'Unavailable';
        stockEl.textContent = '';
      } else if (!v.available) {
        addBtn.disabled = true; addLabel.textContent = 'Sold out';
        stockEl.textContent = 'This combination is sold out.'; stockEl.className = 'll-pdp__stock is-out';
      } else {
        addBtn.disabled = false; addLabel.textContent = 'Add to bag';
        var q = stock[v.id];
        stockEl.textContent = q ? 'Only ' + q + ' left — order soon' : 'In stock, ready to ship';
        stockEl.className = 'll-pdp__stock ' + (q ? 'is-low' : 'is-in');
      }
      var sku = $('[data-ll-sku]', root); if (sku && v) sku.textContent = v.sku || '—';
      if (v && fromUser) {
        try { var u = new URL(win.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        if (v.featured_media) showMedia(v.featured_media.id);
      }
      if (msg && v) msg.hidden = true;
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-ll-opt-input]')) update(true); });

    /* quantity */
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-ll-step]'); if (!s) return;
      var inp = $('.ll-qty__input', root); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(s.getAttribute('data-ll-step'), 10));
    });

    /* add to bag */
    function ask() {
      var sel = selected();
      for (var i = 0; i < sel.length; i++) if (sel[i] === null) {
        sets[i].classList.add('is-invalid');
        msg.textContent = 'Please choose a ' + (missingName() || 'size') + ' first.'; msg.hidden = false;
        sets[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = $('input:not(:disabled)', sets[i]); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
        return true;
      }
      return false;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current) { if (!ask()) { msg.textContent = 'This combination is unavailable.'; msg.hidden = false; } return; }
      if (!current.available || !win.LoveLaceShop) return;
      addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true');
      win.LoveLaceShop.add(new FormData(form), addBtn).catch(function (err) {
        msg.textContent = (err && (err.description || err.message)) || 'Could not add to bag — please try again.'; msg.hidden = false;
      }).then(function () { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); });
    });

    /* sticky mobile bar */
    var bar = $('[data-ll-pdp-bar]', root);
    if (bar && 'IntersectionObserver' in win) {
      new IntersectionObserver(function (es) {
        var en = es[0], show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-ll-bar-add]', bar).tabIndex = show ? 0 : -1;
        doc.body.classList.toggle('ll-has-pdp-bar', show);
      }).observe($('.ll-pdp__buy', root));
      $('[data-ll-bar-add]', bar).addEventListener('click', function () {
        if (!current) { ask(); return; }
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    /* gallery */
    var track = $('[data-ll-media-track]', root);
    var countEl = $('[data-ll-media-count]', root), barEl = $('[data-ll-media-bar]', root);
    var slides = $$('.ll-pdp__slide', root);
    function showMedia(id) {
      var s = $('.ll-pdp__slide[data-media-id="' + id + '"]', root); if (!s) return;
      if (win.matchMedia('(min-width: 990px)').matches) {
        if (s !== track.firstElementChild) { track.insertBefore(s, track.firstElementChild); s.classList.add('is-swapped'); setTimeout(function () { s.classList.remove('is-swapped'); }, 700); }
      } else {
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    if (track && countEl) {
      var tick = false;
      track.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () {
          tick = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          countEl.textContent = Math.min(slides.length, i + 1);
          if (barEl) barEl.style.setProperty('--p', ((i + 1) * 100 / slides.length) + '%');
        });
      }, { passive: true });
    }

    /* lightbox */
    var lb = $('[data-ll-lightbox]', root), lbTrack = lb && $('[data-ll-lb-track]', lb), lbSlides = lb ? $$('.ll-lb__slide', lb) : [], lbIndex = 0, lbReturn = null;
    function lbLoad(i) { [i - 1, i, i + 1].forEach(function (k) { var s = lbSlides[k]; if (s) { var im = $('img', s); if (im && !im.src) im.src = im.getAttribute('data-src'); } }); }
    function lbGo(i, smooth) {
      if (!lbSlides.length) return;
      lbIndex = (i + lbSlides.length) % lbSlides.length; lbLoad(lbIndex);
      lbTrack.scrollTo({ left: lbSlides[lbIndex].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      $('[data-ll-lb-count]', lb).textContent = (lbIndex + 1) + ' / ' + lbSlides.length;
      $$('.ll-lb__thumb', lb).forEach(function (t, k) { t.classList.toggle('is-active', k === lbIndex); if (k === lbIndex) t.scrollIntoView({ block: 'nearest', inline: 'center' }); });
      $$('.ll-lb__slide.is-zoomed', lb).forEach(function (s) { s.classList.remove('is-zoomed'); });
    }
    function lbOpen(mediaIndex, from) {
      if (!lb) return;
      var target = 0; lbSlides.forEach(function (s, k) { if (+s.getAttribute('data-index') === mediaIndex) target = k; });
      lbReturn = from; lb.hidden = false; lock(true);
      requestAnimationFrame(function () { lb.classList.add('is-open'); lbGo(target, false); $('[data-ll-lb-close]', lb).focus(); });
    }
    function lbClose() { if (!lb || lb.hidden) return; lb.classList.remove('is-open'); lb.hidden = true; lock(false); if (lbReturn) lbReturn.focus(); }
    if (lb) {
      root.addEventListener('click', function (e) {
        var o = e.target.closest('[data-ll-lightbox-open]'); if (o) { lbOpen(+o.getAttribute('data-ll-lightbox-open'), o); return; }
        if (e.target.closest('[data-ll-lb-close]')) { lbClose(); return; }
        var st = e.target.closest('[data-ll-lb-step]'); if (st) { lbGo(lbIndex + +st.getAttribute('data-ll-lb-step'), true); return; }
        var g = e.target.closest('[data-ll-lb-go]'); if (g) { var gi = +g.getAttribute('data-ll-lb-go'); lbSlides.forEach(function (s, k) { if (+s.getAttribute('data-index') === gi) lbGo(k, true); }); return; }
        var sl = e.target.closest('.ll-lb__slide'); if (sl) {
          var zoom = !sl.classList.contains('is-zoomed'); sl.classList.toggle('is-zoomed', zoom);
          if (zoom) { var r = sl.getBoundingClientRect(), im = $('img', sl); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; }
        }
      });
      lb.addEventListener('mousemove', function (e) {
        var sl = e.target.closest('.ll-lb__slide.is-zoomed'); if (!sl) return;
        var r = sl.getBoundingClientRect(); $('img', sl).style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      var lbTick = false;
      lbTrack.addEventListener('scroll', function () {
        if (lbTick) return; lbTick = true;
        requestAnimationFrame(function () {
          lbTick = false; var i = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
          if (i !== lbIndex) { lbIndex = i; lbLoad(i); $('[data-ll-lb-count]', lb).textContent = (i + 1) + ' / ' + lbSlides.length; $$('.ll-lb__thumb', lb).forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
        });
      }, { passive: true });
      doc.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowRight') lbGo(lbIndex + 1, true);
        else if (e.key === 'ArrowLeft') lbGo(lbIndex - 1, true);
        else if (e.key === 'Tab') { var f = $$('button', lb); if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
      });
    }

    /* size guide */
    var sg = $('[data-ll-sizeguide]', root), sgReturn = null;
    function sgClose() { if (!sg || sg.hidden) return; sg.classList.remove('is-open'); sg.hidden = true; lock(false); if (sgReturn) sgReturn.focus(); }
    if (sg) {
      root.addEventListener('click', function (e) {
        var o = e.target.closest('[data-ll-sizeguide-open]');
        if (o) { sgReturn = o; sg.hidden = false; lock(true); requestAnimationFrame(function () { sg.classList.add('is-open'); $('[data-ll-sizeguide-close]', sg).focus(); }); return; }
        if (e.target.closest('[data-ll-sizeguide-close]') || e.target === sg) sgClose();
      });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') sgClose(); });
    }

    update(false);
  }

  /* ================= related / upsell tabs ================= */
  function initRecs(sec) {
    if (!sec || sec.__ll) return; sec.__ll = true;
    var pid = sec.getAttribute('data-product-id'), lim = sec.getAttribute('data-limit') || 8;
    var tabs = $$('[data-ll-tab]', sec);
    function panel(name) { return $('[data-ll-panel="' + name + '"]', sec); }
    function select(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-ll-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        panel(t.getAttribute('data-ll-tab')).hidden = !on;
        if (on && focus) t.focus();
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-ll-tab')); });
      t.addEventListener('keydown', function (e) {
        var vis = tabs.filter(function (x) { return !x.hidden; }), k = vis.indexOf(t);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = vis[(k + (e.key === 'ArrowRight' ? 1 : -1) + vis.length) % vis.length]; select(n.getAttribute('data-ll-tab'), true); }
      });
    });
    $$('[data-ll-recs-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var row = $('.ll-recs__panel:not([hidden]) .ll-recs__row', sec); if (!row) return;
        row.scrollBy({ left: row.clientWidth * 0.85 * +b.getAttribute('data-ll-recs-step'), behavior: 'smooth' });
      });
    });
    function count(name) { return $$('.ll-recs__item', panel(name)).length; }
    function tidy(final) {
      var up = tabs.filter(function (t) { return t.getAttribute('data-ll-tab') === 'upsell'; })[0];
      var rel = tabs.filter(function (t) { return t.getAttribute('data-ll-tab') === 'related'; })[0];
      up.hidden = count('upsell') === 0; rel.hidden = count('related') === 0;
      if (rel.hidden && !up.hidden) select('upsell');
      if (final) sec.hidden = rel.hidden && up.hidden;
      sec.classList.toggle('is-single', rel.hidden || up.hidden);
    }
    function fetchRecs(intent, name, min) {
      var url = (LL.routes && LL.routes.root ? LL.routes.root.replace(/\/$/, '') : '') + '/recommendations/products?product_id=' + pid + '&limit=' + lim + '&intent=' + intent + '&section_id=ll-recs-grid';
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var items = $$('.ll-recs__item', tmp);
        if (items.length >= min) { var list = $('[data-ll-recs-list]', panel(name)); list.innerHTML = ''; items.forEach(function (li) { list.appendChild(li); }); }
      }).catch(function () {});
    }
    function load() {
      var jobs = [fetchRecs('related', 'related', 3)];
      if (panel('upsell').getAttribute('data-mode') === 'auto') jobs.push(fetchRecs('complementary', 'upsell', 2));
      Promise.all(jobs).then(function () { tidy(true); if (win.LoveLaceMotion && win.LoveLaceMotion.initReveals) win.LoveLaceMotion.initReveals(sec); doc.dispatchEvent(new CustomEvent('ll:recs:loaded')); });
    }
    tidy();
    if ('IntersectionObserver' in win) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
      io.observe(sec);
    } else load();
  }

  function boot(scope) { $$('[data-ll-pdp]', scope).forEach(initPdp); $$('[data-ll-recs-tabs]', scope).forEach(initRecs); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
